import React, { Component } from 'react';

import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';

import { toFriendlyDateString } from 'helpers/Formatter';
import { AccentColor } from 'helpers/AccentColorHelper';
import { formatPhone } from 'helpers/Formatter';
import { getTranslatedString } from 'helpers/i18n';
const customContentStyle = {
  maxWidth: '400px',
  width: '95%',
};

const titleContentStyle = {
  borderBottom: '0px solid #e0e0e0',
  padding: '20px 20px 5px 20px',
  textAlign: 'center',
  color: '#4e4e4e',
};

const bodyContentStyle = {
  padding: '20px',
};

class VendorInfoDialog extends Component {
  handleClose = () => {
    this.props.closeVendorInfoDialog();
  };

  deleteVendor = vendor_id => {
    this.props.deleteVendor(vendor_id);
  };

  openEditVendorInfo = () => {
    this.props.closeVendorInfoDialog();
    this.props.openEditVendorDialog();
  };

  render() {
    const data = this.props.vendorDetails;
    const actions = [
      <FlatButton
        label={getTranslatedString('landlordPortal.vendors.close')}
        primary={true}
        onClick={this.handleClose}
      />,
    ];

    const receiptId = data.id;

    const style = {
      bold_padding: {
        padding: '0px 5px',
        fontWeight: '800',
      },
      padding_right: {
        padding: '0px 5px',
        fontWeight: '800',
      },
      padding_top_and_right: {
        padding: '20px 5px 0px 0px',
        textAlign: 'right',
      },
      receipt_header: {
        margin: '5px -20px 10px -20px',
        backgroundColor: '#f1f1f1',
        padding: '5px 10px',
        fontSize: '14px',
        fontWeight: '800',
      },
      rent_breakdown: {
        fontSize: '15px',
        marginTop: '15px',
      },
      right_align_p: {
        textAlign: 'right',
        marginBottom: '1px',
      },
      payment_details: {
        fontSize: '12px',
      },
    };

    return (
      <div>
        <Dialog
          disableBackdropClick
          title={getTranslatedString('landlordPortal.vendors.vendorDetailsTitle')}
          actions={actions}
          modal={false}
          open={this.props.vendorDialogIsOpen}
          contentStyle={customContentStyle}
          onRequestClose={this.handleClose}
          titleStyle={titleContentStyle}
          bodyStyle={bodyContentStyle}
          autoScrollBodyContent={true}
          className={'receipt-' + String(receiptId)}
        >
          <div className="row">
            <div className="col-xs-7" style={{ padding: '0px 5px' }}>
              <p id="no-margin">{data.name}</p>
              {!data.street && (
                <p id="no-margin">{getTranslatedString('landlordPortal.vendors.noAddress')}</p>
              )}
              {data.street && (
                <div>
                  <p id="no-margin">{data.street}</p>
                  <p id="no-margin">
                    {data.city}, {data.country}
                  </p>
                </div>
              )}
            </div>
            <div className="col-xs-5" style={style.padding_top_and_right}>
              <FlatButton
                label={getTranslatedString('landlordPortal.vendors.editVendor')}
                primary={true}
                keyboardFocused={false}
                onClick={this.openEditVendorInfo}
                style={{ color: '#fff', backgroundColor: AccentColor() }}
              />
            </div>
          </div>
          <div className="row" style={{ marginTop: '20px' }}>
            <div className="col-xs-12" style={{ padding: '0px 5px' }}>
              <p style={{ fontWeight: '800' }}>
                {data.amount_outstanding}{' '}
                {getTranslatedString('landlordPortal.vendors.outstanding')}
              </p>
            </div>
          </div>

          <div className="row" style={style.receipt_header}>
            <div className="col-xs-12">
              <p style={{ margin: '0' }}>
                {' '}
                {getTranslatedString('landlordPortal.vendors.vendorDetailsTitle')}{' '}
              </p>
            </div>
          </div>

          <div className="row">
            {data.is_onsite_supplier && (
              <div className="col-xs-6" style={{ padding: '0' }}>
                <h6> {getTranslatedString('landlordPortal.vendors.onsiteSupplier')} </h6>
              </div>
            )}
            {data.contact_number && (
              <div className="col-xs-6" style={{ padding: '0' }}>
                <h6 style={{ marginBottom: '5px' }}>
                  {' '}
                  {getTranslatedString('landlordPortal.vendors.contactNumber')}{' '}
                </h6>
                <p style={{ fontSize: '13px' }}> {formatPhone(data.contact_number)} </p>
              </div>
            )}
            {data.contact_number && (
              <div className="col-xs-6" style={{ padding: '0' }}>
                <h6 style={{ marginBottom: '5px' }}>
                  {' '}
                  {getTranslatedString('landlordPortal.vendors.contactEmail')}{' '}
                </h6>
                <p style={{ fontSize: '13px' }}> {data.contact_email} </p>
              </div>
            )}
          </div>

          {data.insurance_number && (
            <div className="row">
              <div className="col-xs-6" style={{ padding: '0' }}>
                <h6 style={{ marginBottom: '5px' }}>
                  {' '}
                  {getTranslatedString('landlordPortal.vendors.vendorInsurance')}{' '}
                </h6>
                <p style={{ fontSize: '13px' }}> {data.insurance_number} </p>
              </div>
              <div className="col-xs-6" style={{ padding: '0' }}>
                <h6 style={{ marginBottom: '5px' }}>
                  {' '}
                  {getTranslatedString('landlordPortal.vendors.vendorInsuranceDate')}{' '}
                </h6>
                <p style={{ fontSize: '13px' }}>
                  {' '}
                  {toFriendlyDateString(data.insurance_expiry_date)}{' '}
                </p>
              </div>
            </div>
          )}

          <div className="row" style={style.receipt_header}>
            <div className="col-xs-12">
              <p style={{ margin: '0' }}>
                {' '}
                {getTranslatedString('landlordPortal.vendors.vendorNotes')}{' '}
              </p>
            </div>
          </div>

          <div className="row">
            <div className="col-xs-12" style={{ padding: '0px 5px' }}>
              <p id="no-margin">{data.notes}</p>
            </div>
          </div>

          {data.vendor_transactions.length > 0 && (
            <div className="row">
              <div className="row" style={style.receipt_header}>
                <div className="col-xs-12">
                  <p style={{ margin: '0' }}>
                    {' '}
                    {getTranslatedString('landlordPortal.vendors.vendorTransactions')}{' '}
                  </p>
                </div>
              </div>

              <div className="row">
                <div className="row">
                  <div className="col-xs-3" style={{ padding: '0' }} />
                  <div className="col-xs-3" style={{ padding: '0' }}>
                    <h6 style={{ marginBottom: '5px' }}>
                      {' '}
                      {getTranslatedString('landlordPortal.vendors.amount')}{' '}
                    </h6>
                  </div>
                  <div className="col-xs-3" style={{ padding: '0' }}>
                    <h6 style={{ marginBottom: '5px' }}>
                      {' '}
                      {getTranslatedString('landlordPortal.vendors.refNo')}{' '}
                    </h6>
                  </div>
                  <div className="col-xs-3" style={{ padding: '0' }}>
                    <h6 style={{ marginBottom: '5px' }}>
                      {' '}
                      {getTranslatedString('landlordPortal.vendors.paid')}{' '}
                    </h6>
                  </div>
                </div>
                {data.vendor_transactions.map((payment, index) => (
                  <div key={index} className="row">
                    <div className="col-xs-3" style={{ padding: '0' }}>
                      <p style={style.payment_details}>{payment.property}</p>
                    </div>
                    <div className="col-xs-3" style={{ padding: '0' }}>
                      <p style={style.payment_details}>{payment.amount}</p>
                    </div>
                    <div className="col-xs-3" style={{ padding: '0' }}>
                      <p style={style.payment_details}>{payment.reference_number}</p>
                    </div>
                    <div className="col-xs-3" style={{ padding: '0' }}>
                      <p style={style.payment_details}>{payment.paid}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </Dialog>
      </div>
    );
  }
}

export default VendorInfoDialog;
